module.exports = __webpack_public_path__ + "img/collection-memoireRings.628a153.jpg";